import React from "react";
const PreviewIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    height="1em"
    width="1em"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.5979 17.3572L15.5123 13.2716C15.3989 13.1581 15.2451 13.0951 15.0837 13.0951H14.6727C15.3686 12.205 15.7821 11.0855 15.7821 9.86763C15.7821 6.9705 13.4347 4.62305 10.5376 4.62305C7.64042 4.62305 5.29297 6.9705 5.29297 9.86763C5.29297 12.7648 7.64042 15.1122 10.5376 15.1122C11.7554 15.1122 12.8749 14.6987 13.765 14.0028V14.4138C13.765 14.5751 13.828 14.729 13.9415 14.8424L18.0271 18.928C18.2641 19.165 18.6473 19.165 18.8818 18.928L19.5954 18.2144C19.8324 17.9774 19.8324 17.5942 19.5979 17.3572ZM10.5376 13.0951C8.7549 13.0951 7.31012 11.6528 7.31012 9.86763C7.31012 8.08498 8.75238 6.64019 10.5376 6.64019C12.3202 6.64019 13.765 8.08245 13.765 9.86763C13.765 11.6503 12.3227 13.0951 10.5376 13.0951Z"
      fill="white"
    />
    <path
      d="M17.2063 10.5274L17.2063 2.75044L3.45366 2.75044L3.45366 16.5031L11.3298 16.5031C11.4673 16.5031 11.5963 16.559 11.6951 16.6535L13.4142 18.3726C13.7408 18.6993 13.5088 19.2537 13.0489 19.2537L2.76603 19.2537C1.62713 19.2537 0.703125 18.3297 0.703125 17.1908L0.703123 2.06281C0.703123 0.923911 1.62713 -9.92629e-05 2.76603 -9.93625e-05L17.894 -0.000100685C19.0329 -0.000100785 19.9569 0.923909 19.9569 2.0628L19.9569 12.2465C19.9569 12.7063 19.4025 12.9341 19.0759 12.6118L17.3568 10.8927C17.2622 10.7939 17.2063 10.6649 17.2063 10.5274Z"
      fill="white"
    />
  </svg>
);
export default PreviewIcon;
